// extracted by mini-css-extract-plugin
export default {"organizationView":"OrganizationView_organizationView__yyT9k"};